import React, { useState } from 'react';
import { Icons } from '../BootstrapComponents/BootstrapComponents';
import './Accordion.scss';

export default function AccordionWithPreview(props) {
  const {
    content = null, title = '', required = null, component: Component = null, componentProps = {},
  } = props;

  const [toggle, setToggle] = useState(false);

  return (
    <div className="accordion-with-spoiler">
      <div className="accordion-with-spoiler-header">
        <div>{title}</div>
        <Icons className="hide-icon" customIcon width={24} height={24} icon="spoiler" onClick={() => setToggle(!toggle)} />
      </div>
      <div className="accordion-with-spoiler-content">
        { Component ? <Component {...componentProps} isPreview={!toggle} /> : toggle ? content : required}
      </div>
      <div className="accordion-with-spoiler-control">
        <div className="accordion-with-spoiler-control-button" onClick={() => setToggle(!toggle)}>
          <Icons customIcon width={10} height={6} icon={toggle ? 'hide-arrow' : 'open-arrow'} onClick={() => setToggle(!toggle)} />
          {toggle ? 'Скрыть' : 'Отобразить' }
        </div>
      </div>
    </div>
  );
}
